import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateFormFieldProps, DatePickerFieldProps, TimePickerFieldProps } from "../types";
import React from "react";
import toDayjsValue from "utils/client/toDayjsValue";

const DateFormField = React.memo(function DateFormField({ name, label, disabled = false, time, required, props, renderInputProps = {} }: DateFormFieldProps) {
  const textFieldProps = {
    id: name,
    name,
    disabled,
    required,
    fullWidth: true,
    type: "text",
    ...renderInputProps,
    // an explicit `error` overrides the picker's own validation error, so only pass it when forcing an error
    error: renderInputProps.error ? true : undefined,
    helperText: renderInputProps.helperText,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {!time ? (
        <DesktopDatePicker
          disabled={disabled}
          label={label}
          {...(props as DatePickerFieldProps)}
          value={toDayjsValue(props.value)}
          slotProps={{ textField: textFieldProps }}
        />
      ) : (
        <DesktopTimePicker
          disabled={disabled}
          label={label}
          {...(props as TimePickerFieldProps)}
          value={toDayjsValue(props.value)}
          slotProps={{ textField: textFieldProps }}
        />
      )}
    </LocalizationProvider>
  );
});

export default DateFormField;
